/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { WorkCategoryAllSupported } from '@jira/servicedesk__work-category/src/WorkCategoryAllSupported.types.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_ISSUE_TYPES } from './resourceTypeServicedeskIssueTypes.constants.tsx';

type Data = Record<
	WorkCategoryAllSupported,
	{
		issueTypes: {
			id: string;
			description: string;
			name: string;
			iconUrl: string;
			subtask: boolean;
		}[];
	}
>;

export const servicedeskIssueTypesResource: RouteResource<Data | null> =
	createResource<Data | null>({
		type: RESOURCE_TYPE_SERVICEDESK_ISSUE_TYPES,
		getKey: ({ match: { params } }) => params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-issue-types", jiraSpaEntry: "async-resource-servicedesk-issue-types" */ './getData.tsx'
			),
	});
